/**
 * GEO 分数差值的**唯一**格式口径 —— 首页「较上轮」、报告页 Hero「较基线轮」、12 基线对比表共用。
 *
 * ★1006 演示机最终回归:报告页 Hero 直接渲染 `baseline_compare.rows[overall].delta` 原值,写出
 *   「+0 较基线轮」;首页同类数字走 `roundDelta` 保留 1 位小数(+1.3)—— 两处格式各写各的。
 */

/** 差值保留 1 位小数(浮点减法会出 1.3000000000000007);-0 归 0。 */
export function roundDelta(d: number): number {
  const r = Math.round(d * 10) / 10;
  return r === 0 ? 0 : r;
}

/** 「+1.3」/「-2」/「0」:正数带 +,最多 1 位小数。 */
export function formatScoreDelta(d: number): string {
  const r = roundDelta(d);
  return r > 0 ? `+${r}` : `${r}`;
}

/** 绝对值(配 ↑/↓ 箭头用),同 1 位小数口径。 */
export function formatScoreDeltaAbs(d: number): string {
  return `${Math.abs(roundDelta(d))}`;
}
